import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StorageService } from '../services/storage.service';
import { AppSettings } from '../app.settings';
import { catchError, map } from 'rxjs/operators';
import { errors } from './errors';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AlertController, LoadingController } from '@ionic/angular';
import { InteractionRequiredAuthError } from '@azure/msal-common';
import { BrowserAuthError } from '@azure/msal-browser';
import { EventService } from './event.service';
const TOKEN_KEY = 'auth-token';
@Injectable({
  providedIn: 'root'
})

export class RestService {

  baseUrl: string = `${environment.baseUrl}`;
  headers: any;
  accessToken: string = '';
  constructor(private httpClient: HttpClient,
    private loadingController: LoadingController,
    private router: Router,
    private msal: MsalService,
    private storage: StorageService,
    private event: EventService,
    private alertController: AlertController) {
    this.storage.get('auth-token').then((result) => {
      this.accessToken = result;

    })
    this.headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': localStorage.getItem('accessToken') });
    //this.headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': 'U3luZ2VudGEgQVBJIEtleQ==' });
  }

  /**
* Get data from the REST API 
* map the result to return only the results that we need
* 
* @param {string} method Name of method in API
* @param {queryString} query value in the get API
* @returns Observable with the response
*/
  public getData(method: string, queryString: string): Observable<any> {
    // this.storage.get('auth-token').then((result) => {
    //   this.accessToken = result;
    //   this.headers['Authorization'] = this.accessToken;
    // })
    let headerNew = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': localStorage.getItem('accessToken') })
    return this.httpClient
      .get(this.baseUrl + method + '/' + queryString, { headers: headerNew }).pipe(
        map(res => {
          return res;
        }),
        catchError(error => {
          if (error instanceof HttpErrorResponse) {
            console.error('error status = ', error.status);
            console.error('ERROR');
            // console.log('---> filter:', req.params.get('filter'));

            if (error.status === 401) {
              // redirect to error page
              // OR you can use a toast
              console.error('redirect');
              this.redirectUserForToken();
              // window.location.reload();
              //this.router.navigate(['login'], { replaceUrl: true });
            }

            
          }
          return throwError(error);
        })
      );
  }

  /**
  * Post data to the REST API 
  * map the result to return only the results that we need
  * 
  * @param {string} method Name of method in API
  * @param {queryData} postDataValeu value in the get API
  * @returns Observable with the response
  */

  public postData(method: string, queryData: any): Observable<any> {
    // this.storage.get('auth-token').then((result) => {
    //   this.accessToken = result;
    //   this.headers['Authorization'] = this.accessToken;
    // })
    //this.headers['Authorization'] = localStorage.getItem('accessToken');
    //console.log(localStorage.getItem('accessToken'));
    // this.headers['Authorization'] = 'U3luZ2VudGEgQVBJIEtleQ==';
    let headerNew = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': localStorage.getItem('accessToken') });
    return this.httpClient
      .post(this.baseUrl + method, queryData, { headers: headerNew }).pipe(
        map(res => {
          return res;
        }),
        catchError(error => {
          if (error instanceof HttpErrorResponse) {
            console.error('error status = ', error.status);
            console.error('ERROR');
            // console.log('---> filter:', req.params.get('filter'));

            if (error.status === 401) {
              // redirect to error page
              // OR you can use a toast
              console.error('redirect');
              this.redirectUserForToken();
              // window.location.reload();
              //this.router.navigate(['login'], { replaceUrl: true });
            }


          }
          return throwError(error);
        })
      );
  }

  async showAlert(){
    const alert = await this.alertController.create({
      header: 'Unauthorized!',
      message: 'You do not have authorization to access this Application',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            
          }
        }
      ]
    });
    await alert.present();
  }

  public getDataBeforeAuth(method: string, queryString: string): Observable<any> {
    return this.httpClient
      .get(this.baseUrl + method + '?' +queryString).pipe(
        map(res => {
          return res;
        }),
        catchError(error => {
          if (error instanceof HttpErrorResponse) {
            console.error('error status = ', error.status);
            console.error('ERROR');
            localStorage.setItem('isAuth','false');
              this.showAlert();            
          }
          return throwError(error);
        })
      );
  }

  private errorHandler(error: HttpErrorResponse) {
    // To know weather the error is from Client or server error
    if (error.error instanceof ErrorEvent) {
      console.log('Client side error. Please check the request and body');
    } else {
      console.log('Server Error. Please check the error from server side', error);
      if (error.status === 401) {
        //this.redirectUserForToken();
        //this.router.navigate(['login'], { replaceUrl: true });
      }

      // if (error.status === 403) {
      //     // window.location.reload();
      //     this.logOutUser();

      // }
    }
    // get's error message from errors.json.ts
    let errorMessage = errors['default'].message;
    if (errors.hasOwnProperty(error.status)) {
      errorMessage = errors[error.status].message;
    }
    return throwError(errorMessage);
  }

  logoutUser() {
    this.router.navigate(['login'], { replaceUrl: true });
  }

  redirectUserForToken() {
    this.msal.instance.acquireTokenSilent(environment.adalConfig).then(data => {
      this.accessToken = data.accessToken;

      localStorage.setItem('accessToken', 'Bearer ' + data.accessToken);
      this.storage.set(TOKEN_KEY, 'Bearer ' + data.accessToken).then(() => {
        this.hideGlobalLoader();
        // window.alert('=== FRESH TOKEN ===')
      });
      //window.location.reload();
    }, err => {
      console.log('ERROR HANDLER')
      this.hideGlobalLoader();
      if (err instanceof InteractionRequiredAuthError) {
        this.msal.instance.acquireTokenRedirect(environment.adalConfig);
      } else if (err instanceof BrowserAuthError) {
        //this.logout();
        this.msal.instance.loginRedirect(environment.adalConfig);
      }
    })
  }

  async hideGlobalLoader() {
    try {
      const element = await this.loadingController.getTop();
      if (element != null) {
        this.loadingController.dismiss();
        return;
      }
    } catch (error) {
    }
  }

}



